var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_65",
    "data-name": "Groupe 65",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.75,
    height: 20.75,
    viewBox: "0 0 20.75 20.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_70",
    "data-name": "Trac\\xE9 70",
    d: "M18.1,18.375l3.458-3.458m0,0L18.1,11.458m3.458,3.458H9.458m5.187,3.458v.865a2.6,2.6,0,0,1-2.594,2.594H8.594A2.6,2.6,0,0,1,6,19.24V10.594A2.6,2.6,0,0,1,8.594,8h3.458a2.6,2.6,0,0,1,2.594,2.594v.865",
    transform: "translate(-3.406 -4.542)",
    fill: "none",
    stroke: "#f9423a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_71",
    "data-name": "Trac\\xE9 71",
    d: "M0,0H20.75V20.75H0Z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.6d0d442c4e4f21aa3d9d3f370e1cc6b9.svg";
export { ForwardRef as ReactComponent };